import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Page, Group, Layout, Button } from "@/comn/components";
import { useForm, useFetch, usePage } from "@/comn/hooks";
import { URLS, APIS, SF_GFS_CD } from "./services/OsciGfsMgmtService"; // 서비스

/*
 * GFS Code Detail
 * !== GFS 코드 상세 ==!
 */
export const OSCI0406006Q = () => {
    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0019", "auth_osci0021"],
    });
    const { t } = useTranslation(); // Translation Hook !== 언어 변환 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const { gfsCd } = useParams(); // Key Information of this Component Router !== 라우터에 정의된 키정보 ==!

    /*
     * @ 화면에서 사용하는 form 객체를 선언
     * @ 기본 변수명은 메타 단어 조합 카멜 표기법을 따름
     * @ 검색 조건일 경우 구분을 위해 폼 이름 뒤에 Srch
     * @ const form = {
     *      [form 이름] : useForm({
     *          defaultSchema: [form의 schema 구조],
     *          defaultValues: [form의 기본 값] || {},
     *      }),
     *      ...
     * }
     */

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // GFS Code General !== GFS 코드 일반 ==!
        gfsCdGnrl: useForm({
            defaultSchema: SF_GFS_CD,
            defaultValues: {},
        }),
    };

    /*
     * 화면에서 사용하는 api 호출 객체를 선언
     * 기본 변수명은 메타 단어 조합 카멜 표기법을 따름
     * Back-End Controller 메소드명과 동일하게 작성(Back-End 개발 가이드 참조)
     * 
     * 다건 조회    get         getRpckItmAppList
     * 단건 조회    get         getRpckItmApp
     * 등록         create      createRpckItmApp
     * 수정         update      updateRpckItmApp
     * 삭제         delete      deleteRpckItmApp
     * 저장 단건    save        saveRpckItmApp
     * 저장 다건    save        saveRpckItmAppList
     * 실행         execute     executeRpckItmApp
     * 
     * const fetch = {
     *      [fetch 이름] : useFetch({
     *          api: [fetch 실행 api, service 파일의 APIS 에 기재],
     *          enabled: [[fetch 가 실행되기 위한 조건]],
                key: [[fetch 에서 변화를 감지하여 자동실행할 변수]],
                onSuccess : [fetch 실행 성공시 실행],
                onError : [fetch 실행 실패시 실행],
                showToast: [성공/실패 결과 Toast메세지 표시 여부],
     *      }),
     *      ...
     * }
     */

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // Get GFS Code !== GFS 코드 조회 ==!
        getGfsCd: useFetch({
            api: (data) => APIS.getGfsCd(gfsCd),
            enabled: !!gfsCd,
            onSuccess: (data) => {
                form.gfsCdGnrl.setValues({
                    ...data.gfsCdInfo.content,
                });
            },
            onError: (error) => {},
            showToast: true,
        }),
    };

    /*
     * 화면에서 사용하는 이벤트, 함수를 선언
     * 기본 변수명은 메타 단어 조합 카멜 표기법을 따름
     * fetch 를 호출 하는 메소드: fetch 명과 동일하게 작성
     * 버튼이나 그리드의 이벤트의 경우 : [이벤트종류]_[이벤트대상타입]_[이벤트대상명]
     * 이벤트 대상 타입 : Btn , Grid ... 카멜표기법으로 표시, 첫글자 대문자
     * 이벤트 명 : 카멜표기법으로 표시, 첫글자 대문자
     *
     * const handler = {
     *      [handler 이름] : ()=>{ 함수 },
     *      click_Btn_Save : 저장버튼 클릭
     *      click_Grid_RpckItmAppList : 재포장 품목 신청서 그리드 클릭
     *      ...
     * }
     */

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {};

    useEffect(() => {
        form.gfsCdGnrl.setEditable(false);
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.gfsCdGnrl.schema.gfsCd} />
                            <Group.Control {...form.gfsCdGnrl.schema.frstRgsrDt} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.gfsCdGnrl.schema.gfsDesc} />
                        </Group.Row>
                    </Group.Section>
                </Group.Body>
            </Group>
            <Layout direction="row">
                <Layout.Left>
                    <Button
                        role="list"
                        onClick={() => {
                            navigate(URLS.osci0406005q);
                        }}
                    ></Button>
                </Layout.Left>
                {/* <Layout.Right>
                    {
                        <Layout.Button
                            onClick={() => {
                                navigate(`${URLS.osci0406007s}/${form.gfsCdGnrl.getValues().gfsCd}`);
                            }}
                        >
                            {t("B_UPDT")}
                        </Layout.Button>
                    }
                </Layout.Right> */}
            </Layout>
        </Page>
    );
};
